"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoaQuestionnaireData = exports.EcoaQuestionnaire = exports.EcoaVisit = exports.EcoaVisitStatus = void 0;
var EcoaVisitStatus;
(function (EcoaVisitStatus) {
    EcoaVisitStatus["NotAvailable"] = "NOT_AVAILABLE";
    EcoaVisitStatus["NotDone"] = "NOT_DONE";
    EcoaVisitStatus["Ongoing"] = "ONGOING";
    EcoaVisitStatus["Done"] = "DONE";
})(EcoaVisitStatus = exports.EcoaVisitStatus || (exports.EcoaVisitStatus = {}));
class EcoaVisit {
}
exports.EcoaVisit = EcoaVisit;
class EcoaQuestionnaire {
}
exports.EcoaQuestionnaire = EcoaQuestionnaire;
class EcoaQuestionnaireData {
}
exports.EcoaQuestionnaireData = EcoaQuestionnaireData;
//# sourceMappingURL=ecoaVisit.js.map